import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from "@mui/material";
import React from "react";

interface ActivePlansTableProps {
  key: string | number;
  requestorUserTitle: string | undefined;
  requestDatePersian: string | undefined;
  reviewerUserTitle: string | undefined;
  reviewDatePersian: string | undefined;
  creditStatusTitle: string | undefined;
  amount: number | undefined;
}

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EDEFEF",
    color: "#1D4A87",
    fontWeight: "700",
    fontSize: 14,
    textAlign: "right",
    marginBottom: "0.5rem",
    overflowX: "auto",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "right !important",
    overflowX: "auto",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ActivePlansTable = ({
  key,
  amount,
  creditStatusTitle,
  requestDatePersian,
  requestorUserTitle,
  reviewDatePersian,
  reviewerUserTitle,
}: ActivePlansTableProps) => {
  return (
    <StyledTableRow key={key}>
      {requestorUserTitle === "" ? (
        <StyledTableCell align="center">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
        </StyledTableCell>
      ) : (
        <StyledTableCell component="th" scope="row">
          {requestorUserTitle}
        </StyledTableCell>
      )}
      <StyledTableCell align="right">{requestDatePersian}</StyledTableCell>
      {reviewerUserTitle === "" ? (
        <StyledTableCell align="center">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
        </StyledTableCell>
      ) : (
        <StyledTableCell align="right">{reviewerUserTitle}</StyledTableCell>
      )}
      {reviewDatePersian === "" ? (
        <StyledTableCell align="center">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
        </StyledTableCell>
      ) : (
        <StyledTableCell align="right">{reviewDatePersian}</StyledTableCell>
      )}
      {creditStatusTitle === "" ? (
        <StyledTableCell align="center">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>----</p>
        </StyledTableCell>
      ) : (
        <StyledTableCell align="right">{creditStatusTitle}</StyledTableCell>
      )}
      {
        <StyledTableCell align="right">
          {amount?.toLocaleString("fa")}
        </StyledTableCell>
      }
    </StyledTableRow>
  );
};

export default ActivePlansTable;
